import dmi from './utils/deep-merge-inmutable'
import base from './base'
export default dmi(base, {
  message: {
    userActive: {
      cuilWarningMessage:
        'Al modificar el CUIL del colaborador detectamos que tiene {input} documentos asociados a su legajo. Al guardar los cambios quedarán asociados los documentos al nuevo CUIL.'
    },
    selfService: {
      taskManager: {
        field: {
          cbuAlias: 'CBU',
          cbu: 'CBU',
          copy: 'Copiar CBU',
          account_number: 'CBU'
        }
      }
    }
  }
})
